import React, { useEffect, useState } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import pencil from "../../../assets/Icons/pencil.svg";
import check from "../../../assets/Icons/tick.svg";
import cross from "../../../assets/Icons/wrong tick.svg";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import LocationService from "../../Services/LocationService";
import propertyService from "../../Services/PropertyService";
import { showErrorToast } from "../../Constant/Notification";

const UpdateProperty = () => {
  // PropertyCreation
  const [propertyType, setPropertyType] = useState("");
  const [name, setName] = useState("");
  const [purchaseDate, setPurchaseDate] = useState("");
  const [surveyFee, setsurveyFee] = useState("");
  const [documentCharge, setDocumentCharge] = useState("");

  const [nameCompare, setNameCompare] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false); // To prevent multiple submissions

  const [location, setLocation] = useState({});
  const [locationStateCopy, setLocationStateCopy] = useState({});
  const [plots, setPlots] = useState([]);
  const [propertyId, setPropertyId] = useState("");
  const [plotCount, setPlotCount] = useState({
    available: 0,
    booked: 0,
    agreement: 0,
    registered: 0,
  });
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationLink, setLocationLink] = useState("");

  const [count, setCount] = useState(0);
  const [clickable, setClickable] = useState(false);
  const [errors, setErrors] = useState({
    propertyType: "",
    name: "",
    location: "",
    plots: "",
  });
  
  const [inputList, setInputList] = useState([
    {
      indexValue: "",
      sqftValue: "",
      ratePerSqft: "",
      guidlineSqftPrice: "",
      registrationCharge: "",
      plotStatus: "Available"
    },
  ]);
  const [editableIndex, setEditableIndex] = useState(null);
  const [tempValue, setTempValue] = useState("");

  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSelectedLocation(e);
    // Check if a valid location is selected
    if (e) {
      setErrors({ ...errors, location: "" }); // Clear location error if a valid option is chosen
    } else {
      setErrors({ ...errors, location: "Location is required." });
    }
  };

  const handlePropertyPurchaseDate = (e) => {
    setPurchaseDate(e.target.value);
    if (e.target.value) {
      setErrors({ ...errors, propertyPurchaseDate: "" });
    } else {
      setErrors({
        ...errors,
        propertyPurchaseDate: "Property Purchase Date is required",
      });
    }
  };

  const formatFirestoreTimestampToDate = (firestoreTimestamp) => {
    if (!firestoreTimestamp || !firestoreTimestamp._seconds) return "";
    const date = new Date(firestoreTimestamp._seconds * 1000);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    // Fetch locations when component mounts
    setPropertyId(window.location.href.split("/")[5]);

    const fetchLocation = async () => {
      try {
        const response = await LocationService.fetchLocation();
        const data = response.data;
        const options = Object.entries(data).map(([key, value]) => ({
          label: key,
          value: value,
        }));
        setLocation(options);
        setLocationStateCopy(data);

        const propertyId = window.location.href.split("/")[5];
        const responseProperties = await propertyService.fetchPropertyById(
          propertyId
        );
        const propertyData = responseProperties.data;

        const propertyDetails = propertyData[Object.keys(propertyData)[0]];
        
        setPropertyType(propertyDetails.type);
        setName(propertyDetails.name);
        setsurveyFee(propertyDetails.surveyFee);
        setNameCompare(propertyDetails.name);
        setDocumentCharge(propertyDetails.documentCharge);
        setLocationLink(propertyDetails.locationLink);
        setPurchaseDate(
          formatFirestoreTimestampToDate(propertyDetails.purchaseTime)
        );
        setSelectedLocation(propertyDetails.location.name);
        setPlots(propertyDetails.plots);

        // Sort plots by 'order' field before setting state
        const sortedPlots = propertyDetails.plots.sort(
          (a, b) => a.order - b.order
        );

        let plotSqArray = [];
        let availableCount = 0;
        let bookedCount = 0;
        let agreementCount = 0;
        let registeredCount = 0;
        let isClickable = false;

        sortedPlots.forEach((element) => {
          plotSqArray.push({
            indexValue: element.plotNo,
            sqftValue: element.sqft,
            ratePerSqft: element.ratePerSqft,
            guidlineSqftPrice: element.guidlineSqftPrice,
            plotStatus: element.plotStatus,
            registrationCharge: element.registrationCharge,
            order: element.order,
          });

          switch (element.plotStatus) {
            case "Available":
              availableCount++;
              break;
            case "Booked":
              bookedCount++;
              isClickable = true;
              break;
            case "Agreement":
              agreementCount++;
              isClickable = true;
              break;
            case "Registered":
              registeredCount++;
              isClickable = true;
              break;
            default:
              break;
          }
        });

        setPlotCount({
          available: availableCount,
          booked: bookedCount,
          agreement: agreementCount,
          registered: registeredCount,
        });

        setClickable(isClickable);
        setInputList(plotSqArray);
        setCount(sortedPlots.length);
      } catch (error) {
        console.error("Error fetching property:", error);
        showErrorToast("Error fetching property details");
      }
    };

    fetchLocation();
  }, []);

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      propertyType: "",
      name: "",
      location: "",
    };

    if (!propertyType) {
      newErrors.propertyType = "Property type is required.";
      isValid = false;
    }
    if (!name) {
      newErrors.name = "Name is required.";
      isValid = false;
    }
    if (!selectedLocation) {
      newErrors.location = "Location is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    
    // Prevent multiple submissions
    if (isSubmitting || loading) {
      return;
    }
    
    setIsSubmitting(true);
    
    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }
    
    if (inputList.length === 0) {
      toast.error("At least one plot is required.", {
        position: "top-center",
        theme: "light",
      });
      setIsSubmitting(false);
      return;
    }
    
    if (
      !propertyType ||
      !name ||
      !selectedLocation ||
      inputList.some((plot) => plot.indexValue === "" || plot.sqftValue === "")
    ) {
      console.error("Form fields are incomplete.");
      showErrorToast("Please fill all required fields");
      setIsSubmitting(false);
      return;
    }
    
   
    const plotsData = inputList.map((plot, index) => {
      let registrationCharge = plot.registrationCharge;
  if (plot.guidlineSqftPrice && plot.sqftValue) {
    const guidlinePrice = parseFloat(plot.guidlineSqftPrice);
    const sqft = parseFloat(plot.sqftValue);
    registrationCharge = (guidlinePrice * sqft * 0.09).toFixed(2);
  }
      const plotData = {
        id: plot.id || null,
        plotNo: plot.indexValue,
        plotStatus: plot.plotStatus.toUpperCase(),
        sqft: parseInt(plot.sqftValue, 10) || 0,
        ratePerSqft: parseInt(plot.ratePerSqft, 10) || 0,
        guidlineSqftPrice: parseInt(plot.guidlineSqftPrice, 10) || 0,
        order: plot.order || index
      };
      
    
      if (plots[index]?.id) {
        plotData.id = plots[index].id;
      }
      
      return plotData;
    });


    let propertyData = {};

    if (typeof selectedLocation === 'object' && selectedLocation.value) {
      propertyData = {
        type: propertyType,
        locationLink: locationLink || "https",
        surveyFee: Number(surveyFee),
        documentCharge: Number(documentCharge),
        name: name,
        location: { id: selectedLocation.value},
        plots: plotsData,
        purchaseTime: purchaseDate,
      };
    } else {
      propertyData = {
        type: propertyType,
        name: name,
        locationLink: locationLink || "https",
        surveyFee: surveyFee,
        documentCharge: documentCharge,
        location: {
          id: locationStateCopy[selectedLocation],
          name: selectedLocation,
        },
        plots: plotsData,
        purchaseTime: purchaseDate,
      };
    }

    try {
      setLoading(true);
      const response = await propertyService.updatePropertyById(propertyId, propertyData);
      
      toast.success("Property Updated Successfully", {
        position: "top-center",
        theme: "light",
      });
      

      setName("");
      setNameCompare("");
      setLocation("");
      setPurchaseDate("");
      setPropertyType("");
      
      // Delay before navigation to ensure the toast message is seen
      setTimeout(() => {
        if (userRole === "Admin") {
          navigate("/admin/property", {
            state: { message: "Property Updated Successfully" },
          });
        } else if (userRole === "CMO") {
          navigate("/cmo/property", {
            state: { message: "Property Updated Successfully" },
          });
        }
      }, 1500);
    } catch (error) {
      showErrorToast(error.response?.data || "Error updating property");
      console.error("There was an error updating the property:", error);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e, index, field) => {
    let { value } = e.target;

    // Validate input based on the field
    if (field === "sqftValue") {
      // Allow only digits and a single decimal point
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal characters
      const decimalCount = (value.match(/\./g) || []).length; // Count number of decimal points
      if (decimalCount > 1) {
        value = value.slice(0, value.lastIndexOf(".")); // Only allow one decimal point
      }
    } else if (field === "indexValue") {
      // Allow only alphanumeric characters
      value = value
        .replace(/[^a-zA-Z0-9]/g, "")
        .toUpperCase()
        .trim(); // Allow only alphanumeric, trim spaces, convert to uppercase

      // Check for duplicate Plot Number
      const isDuplicate = inputList.some(
        (item, idx) => idx !== index && item.indexValue === value
      );

      if (isDuplicate) {
        showErrorToast("Duplicate Plot Number is not allowed.");
        return; // Prevent updating state
      }
    } else if (field === "ratePerSqft" || field === "guidlineSqftPrice") {
      value = value.replace(/[^0-9.]/g, ""); // Remove non-numeric and non-decimal characters
      const decimalCount = (value.match(/\./g) || []).length; // Count number of decimal points
      if (decimalCount > 1) {
        value = value.slice(0, value.lastIndexOf(".")); // Only allow one decimal point
      }
    } else if (field === "plotStatus") {
      // No validation needed for plot status
    } else if (field === "registrationCharge") {
      value = value.replace(/[^0-9.]/g, "");
    }

    // Make a shallow copy of the inputList
    const newInputList = [...inputList];

    if (typeof newInputList[index] !== "object") {
      newInputList[index] = { 
        indexValue: "", 
        sqftValue: "", 
        ratePerSqft: "",
        guidlineSqftPrice: "",
        registrationCharge: "",
        plotStatus: "Available"
      };
    }

    // Set the field value dynamically
    newInputList[index][field] = value;

    if (field === "sqftValue" || field === "guidlineSqftPrice") {
      const sqft = parseFloat(field === "sqftValue" ? value : newInputList[index].sqftValue) || 0;
      const guidlinePrice = parseFloat(field === "guidlineSqftPrice" ? value : newInputList[index].guidlineSqftPrice) || 0;
      
      if (sqft && guidlinePrice) {
        newInputList[index].registrationCharge = (guidlinePrice * sqft * 0.09).toFixed(2);
      }
    }

   
    if (field === "plotStatus") {
      const oldStatus = inputList[index].plotStatus;
      const newStatus = value;
      
      if (oldStatus !== newStatus) {
        const newPlotCount = { ...plotCount };
   
        if (oldStatus === "Available") newPlotCount.available--;
        else if (oldStatus === "Booked") newPlotCount.booked--;
        else if (oldStatus === "Agreement") newPlotCount.agreement--;
        else if (oldStatus === "Registered") newPlotCount.registered--;
  
        if (newStatus === "Available") newPlotCount.available++;
        else if (newStatus === "Booked") newPlotCount.booked++;
        else if (newStatus === "Agreement") newPlotCount.agreement++;
        else if (newStatus === "Registered") newPlotCount.registered++;
        
        setPlotCount(newPlotCount);
      }
    }

    // Update the state with the new array
    setInputList(newInputList);
  };

  const handleEditClick = (index) => {
    setTempValue({...inputList[index]});
    setEditableIndex(index);
  };

  const handleSaveClick = () => {
    if (editableIndex === null) return;
    
    const currentPlot = inputList[editableIndex];
    if (
      currentPlot.indexValue === "" || 
      currentPlot.sqftValue === ""
    ) {
      showErrorToast("Plot Number and Square Feet are required");
      return;
    }
    
    const newInputList = [...inputList];
    newInputList[editableIndex].indexValue = newInputList[editableIndex].indexValue;
    newInputList[editableIndex].sqftValue = newInputList[editableIndex].sqftValue;
    
 
    if (newInputList[editableIndex].guidlineSqftPrice && newInputList[editableIndex].sqftValue) {
      const guidlinePrice = parseFloat(newInputList[editableIndex].guidlineSqftPrice);
      const sqft = parseFloat(newInputList[editableIndex].sqftValue);
      newInputList[editableIndex].registrationCharge = (guidlinePrice * sqft * 0.09).toFixed(2);
    }
    
    setInputList(newInputList);
    setEditableIndex(null);
    setTempValue({});
  };

  const handleCancelClick = (index) => {
    const newInputList = [...inputList];
    
    newInputList[index] = tempValue;
    setInputList(newInputList);
    setEditableIndex(null);
    setTempValue({});
  };

  const handleBack = () => {
    if (userRole === "Admin") {
      navigate("/admin/property");
    } else if (userRole === "CMO") {
      navigate("/cmo/property");
    }
  };

  const plotStatusEnum = Object.freeze({
    available: "Available",
    booked: "Booked",
    agreement: "Agreement",
    registered: "Registered",
  });


  return (
    <div className="bg-appGrayBackground">
      <AdminAppBar />
      <ToastContainer />
      <div className="mt-20 pt-4 px-6">
        <div className=" flex justify-between">
          <div className="flex gap-6">
            <svg
              onClick={handleBack}
              className=" cursor-pointer"
              width="20"
              height="34"
              viewBox="0 0 22 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
                fill="#399E79"
              />
            </svg>
            <div className="font-semibold md:mx-0 3xl:ml-12 lg:mx-0 md:text-2xl lg:text-4xl">
              Update Property
            </div>
          </div>

          <div className="">
            <button
              onClick={handleSubmit}
              className="bg-customGreen text-white md:w-28  md:h-9 lg:w-48 lg:h-11 rounded-md md:text-xl
          lg:text-2xl font-medium"
              disabled={loading}
            >
              {loading ? (
                <div className="flex justify-center items-center h-full">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-4 border-b-4 border-white"></div>
                </div>
              ) : (
                "Update"
              )}
            </button>
          </div>
        </div>

        <form className="bg-white shadow-md rounded 3xl:w-12/12 3xl:ml-12 md:px- 4 lg:px-8 md:px-4 lg:pt-7 md:pt-6 md:pb-4 lg:pb-8 md:mt-8 lg:mt-8 md:mx-0 lg:mx-0 md:mb-4 lg:w-full md:w-full">
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="lead-source"
            >
              Property Type
            </label>
            <div className="flex w-3/4 relative">
              <select
                className={`appearance-none w-full shadow bg-gray-100 cursor-default border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.propertyType ? "border-red-500" : ""
                }`}
                id="lead-source"
                name="lead-source"
                value={propertyType}
                // disabled={isReadonly}
                disabled={true}
                defaultValue={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                onFocus={() => setErrors({ ...errors, propertyType: "" })}
              >
                <option value=""></option>
                <option value="Layout">Layout</option>
                <option value="Villa">Villa</option>
                <option value="Apartment">Apartment</option>
                <option value="Resale Land">Resale Land</option>
                <option value="Resale Building">Resale Building</option>
                <option value="Acres and Cents">Acres and Cents</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg
                  width="18"
                  height="12"
                  viewBox="0 0 24 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607L22.6066 3.51472C23.1924 2.92893 23.1924 1.97919 22.6066 1.3934C22.0208 0.807611 21.0711 0.807611 20.4853 1.3934L12 9.87868L3.51472 1.3934C2.92893 0.807611 1.97919 0.807611 1.3934 1.3934C0.807611 1.97919 0.807611 2.92893 1.3934 3.51472L10.9393 13.0607ZM10.5 10V12H13.5V10H10.5Z"
                    fill="#399E79"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              htmlFor="name"
            >
              Name
            </label>
            <input
              className={`shadow appearance-none border  cursor-default rounded w-3/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="name"
              type="text"

              placeholder={errors.name || "Enter Property Name"}
              value={name}
              onFocus={() => setErrors({ ...errors, name: "" })}
              onChange={(e) =>
                setName(
                  e.target.value.charAt(0).toUpperCase() +
                    e.target.value.slice(1)
                )
              }
            />
          </div>
          <div className="mb-8 flex  ">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="lead-source"
            >
              Location Link
            </label>

            <div className="flex   cursor-default relative">
              <input
                className={`shadow appearance-none border  cursor-default rounded  py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                  errors.name ? "border-red-500" : ""
                }`}
                id="locationlink"
                onChange={(e) => setLocationLink(e.target.value)}
                value={locationLink}
                placeholder="Select a location"
              />
            </div>
          </div>
          <div className="mb-8 flex  ">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium"
              htmlFor="lead-source"
            >
              Location
            </label>

            <div className="flex w-1/4   cursor-default relative">
              <Dropdown
                id="location"
                options={location}
                onChange={handleChange}
                value={selectedLocation}
                className="w-full bg-gray-100"
                placeholder="Select a location"
              />
            </div>
          </div>
          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Survey Fee
            </label>
            <input
              className={`shadow appearance-none border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="survey-number"
              type="text"
              value={surveyFee}
              placeholder={errors.surveyFee || ""}
              onChange={(e) => setsurveyFee(e.target.value)}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Document Charge
            </label>
            <input
              className={`shadow appearance-none border  rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="Document Charge"
              type="number"
              value={documentCharge}
              min={0}
              placeholder={errors.documentCharge || ""}
             
              onChange={(e) => setDocumentCharge(e.target.value)}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              // htmlFor="name"
            >
              Property Purchase Date
            </label>
            <input
              className={`shadow appearance-none  cursor-default border rounded w-1/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
                errors.name ? "border-red-500" : ""
              }`}
              id="Property-Purchase-Date"
              type="date"
              placeholder={errors.propertyPurchaseDate || ""}
              required
              value={purchaseDate}
              onFocus={() => setErrors({ ...errors, propertyPurchaseDate: "" })}
              onChange={handlePropertyPurchaseDate}
            />
          </div>

          <div className="mb-8 flex items-center">
            <label
              className="w-1/4 text-gray-700 text-2xl font-medium "
              htmlFor="name"
            >
              Total no of Plots
            </label>

            <div className="flex items-center ">
              <input
                type="text"
                readOnly
                className={`shadow appearance-none bg-gray-100 cursor-default border rounded w-4/4 py-2 px-3  text-gray-700 leading-tight focus:outline-none focus:shadow-outline `}
                value={count}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    setCount(value);
                  }
                }}
              />
            </div>
          </div>

          <div className="plot-info-container whitespace-nowrap w-full flex justify-start items-center">
            <div className="plot-inner-container1 flex flex-col xl:w-[45%]">
              <span className="plot-info-heading">Plot Info </span>
              <span className="plot-count">
                &#40;Available:{plotCount.available}, Booked:
                {plotCount.booked},Agreement:{plotCount.agreement},Fully
                Registered:{plotCount.registered}&#41;
              </span>
            </div>

            <div className="plot-inner-container2 whitespace-nowrap flex ">
              <div className="flex">
                <div>
                  <span className="circle grey-circle"></span> Available
                </div>
                <div>
                  <span className="circle orange-circle"></span> Booked
                </div>
              </div>
              <div className="">
                <div>
                  <span className="circle cream-yellow-circle"></span> Agreement
                </div>
                <div>
                  <span className="circle dark-grey-circle"></span> Fully
                  Registered
                </div>
              </div>
            </div>
          </div>

          <div className="plot-tiles">
            {/* <div className="grid xl:grid-cols-3 2xl:grid-cols-3 gap-5 3xl:grid-cols-5 w-6/6 ">
                {inputList.map((input, index) => (
                  <div key={index} className={`flex items-center space-x-2`}>
                    <span className="text-gray-700 font-medium  whitespace-nowrap">
                      Plot
                    </span>


<input
                      type="text"
                      value={input.indexValue}
                      className={`border border-gray-300 px-2 py-1 w-32 rounded focus:outline-none focus:border-blue-500 ${
                        editableIndex === index
                          ? ""
                          : "pointer-events-none bg-gray-100"
                      } ${
                        plots[index]?.plotStatus == "Registered"
                          ? "dark-grey-box"
                          : plots[index]?.plotStatus == "Booked"
                          ? "orange-box"
                          : plots[index]?.plotStatus == "Agreement"? "cream-yellow-box" :"grey-box"
                      }`}

                      onChange={(e) => handleInputChange(e, index, 'indexValue')}
                      placeholder="Plot No"
                    />
                    <input
                      type="text"
                      value={input.sqftValue}


                      onChange={(e) => handleInputChange(e, index, 'sqftValue')}
                      className={`border border-gray-300 px-2 py-1 w-32 rounded focus:outline-none focus:border-blue-500 ${
                        editableIndex === index
                          ? ""
                          : "pointer-events-none bg-gray-100"
                      } ${
                        plots[index]?.plotStatus == "Registered"
                          ? "dark-grey-box"
                          : plots[index]?.plotStatus == "Booked"
                          ? "orange-box"
                          : plots[index]?.plotStatus == "Agreement"? "cream-yellow-box" :"grey-box"
                      }`}
                      placeholder="Sqft value"
                    />
                    {editableIndex === index ? (
                      <>
                        <img
                          src={check}
                          alt="Save"
                          className="w-4 h-4 cursor-pointer"
                          onClick={handleSaveClick}
                        />
                        <img
                          src={cross}
                          alt="Cancel"
                          className="w-4 h-4 cursor-pointer"
                          onClick={() => handleCancelClick(index)}
                        />
                      </>
                    ) : (
                      <>
                        {
                        // plots[index]?.plotStatus ===
                        //   plotStatusEnum.available
                        !isReadonly
                          && (
                          <img
                            src={pencil}
                            alt="Edit"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleEditClick(index)}
                          />
                        )}
                      </>
                    )}

                    {index === inputList.length - 1 && !isReadonly && (


                      <button
                        type="button"
                        className="bg-gray-300 text-gray-800 px-2 py-1 rounded ml-2"
                        onClick={increment}
                      >
                        +
                      </button>
                    )}
                  </div>
                ))}
              </div> */}

            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Plot
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Square Feet
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Approx Rate Per Sqft
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Approx Total Price
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Guidline Sqft Price
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Registration Charge
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-base font-medium text-black-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {inputList.map((input, index) => (
                  <tr key={index}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={input.indexValue}
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none focus:border-blue-500 ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        onChange={(e) =>
                          handleInputChange(e, index, "indexValue")
                        }
                        placeholder="Plot No"
                        readOnly={input?.plotStatus != "Available"}
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={input?.sqftValue}
                        readOnly={input?.plotStatus != "Available"}
                        onChange={(e) =>
                          handleInputChange(e, index, "sqftValue")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none focus:border-blue-500 ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Sqft value"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={input?.ratePerSqft}
                        readOnly={input?.plotStatus != "Available"}
                        onChange={(e) =>
                          handleInputChange(e, index, "ratePerSqft")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none focus:border-blue-500 ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Rate Per Sqft"
                      />
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={input?.ratePerSqft * input?.sqftValue || ""}
                        onChange={(e) =>
                          handleInputChange(e, index, "ratePerSqft")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none focus:border-blue-500 ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Approx Total Price"
                        readOnly={input?.plotStatus != "Available"}
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="text"
                        value={input?.guidlineSqftPrice}
                        readOnly={input?.plotStatus != "Available"}
                        onChange={(e) =>
                          handleInputChange(e, index, "guidlineSqftPrice")
                        }
                        className={`border border-gray-300 px-2 py-1 w-full rounded focus:outline-none focus:border-blue-500 ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Guidline Sqft Price"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <input
                        type="number"
                        value={
                          inputList[index]?.guidlineSqftPrice *
                            inputList[index]?.sqftValue *
                            0.09 || ""
                        }
                        className="border border-gray-300 px-2 py-1 w-full rounded focus:outline-none"
                        onChange={(e) =>
                          handleInputChange(e, index, "registrationCharge")
                        }
                        readOnly
                        placeholder="Enter Registration Cost"
                      />
                    </td>

                    <td className="px-6 py-4 whitespace-nowrap">
                      <select
                        value={input?.plotStatus}
                        onChange={(e) =>
                          handleInputChange(e, index, "plotStatus")
                        }
                        className={`border border-gray-300 px-2  ${
                          input?.plotStatus == "Available"
                            ? "text-customGreen"
                            : input?.plotStatus == "Registered"
                            ? "text-[#999999]"
                            : input?.plotStatus == "Booked"
                            ? "text-[#EE6C4D]"
                            : input?.plotStatus == "Agreement"
                            ? "text-[#EEBB4D]"
                            : "text-black"
                        } py-1 w-full rounded focus:outline-none  ${
                          editableIndex === index
                            ? ""
                            : "pointer-events-none bg-gray-100"
                        }`}
                        placeholder="Status"
                        disabled={input?.plotStatus !== "Available"}
                      >
                        <option
                          style={{ color: "green" }}
                          className="text-green-300"
                          value="Available"
                        >
                          Available
                        </option>
                        <option value="Registered">Registered</option>
                        <option value="Booked">Booked</option>
                        <option value="Agreement">Agreement</option>
                      </select>
                    </td>
                    <td className="flex items-center justify-center pt-6 gap-4 whitespace-nowrap">
                      {editableIndex === index ? (
                        <>
                          <img
                            src={check}
                            alt="Save"
                            className="w-4 h-4 cursor-pointer"
                            onClick={handleSaveClick}
                          />
                          <img
                            src={cross}
                            alt="Cancel"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleCancelClick(index)}
                          />
                        </>
                      ) : (
                        <>
                          <img
                            src={pencil}
                            alt="Edit"
                            className="w-4 h-4 cursor-pointer"
                            onClick={() => handleEditClick(index)}
                          />
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateProperty;
